module.exports = __webpack_public_path__ + "static/media/track-orange.6d4996f9.svg";